<template>
    <div class="position-relative">
      <div class="bg-lightblue px-2 py-2">
<!--                <div class="h3">{{ property.backendName }} </div>-->
<!--                <div v-html="property.names.description" class="d-flex mb-2">-->
<!--                </div>-->
                <div
                    class="input-unit order-property-input"
                    :class="{ 'active': property.value, 'error': hasError }">
                    <select id="order-property-input-select" v-model="selectionValue" @change="onInputValueChanged($event.target.value)" class="custom-select p-3" data-testing="order-property-selection">
                        <option :selected="true" :value="null">{{ $translate("Ceres::Template.singleItemPleaseSelect") }}</option>
                        <option :selected="property.id === id" :value="id" v-for="(value, id) in property.selectionValues" :key="id" data-testing="order-property-selection-option">{{ value.name }}</option>
                    </select>
                    <label class="d-flex w-100" for="order-property-input-select">
                        <span class="text-truncate">{{ property.names.name }}</span>
                        <strong class="ml-1">
                            <template v-if="surcharge > 0">(+ {{ surcharge | currency }})</template><span> {{ footnotes }}</span>
                        </strong>
                    </label>
                </div>
            </div>
    </div>
</template>

<script>
const ApiService = require("../services/ApiService");
const NotificationService = require("../services/NotificationService");

import { isNullOrUndefined } from "../helper/utils";
import { mapState, mapMutations } from "vuex";
import TranslationService from '../services/TranslationService';

export default {

    name: "order-property-list-item-custom",

    props:
    {
        group: Object,
        property: Object
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data()
    {
        return {
            inputValue: "",
            selectedFile: null,
            waiting: false,
            selectionValue: null
        };
    },

    mounted()
    {
        document.addEventListener("onVariationChanged", event =>
        {
            if (event.detail.itemId === this.itemId)
            {
              this.selectionValue = this.property.value || null;
            }
        });
    },

    computed:
    {
        selectedFileName()
        {
            if (this.selectedFile)
            {
                return this.selectedFile.name;
            }

            return "";
        },

        hasError()
        {
            const isRequired = this.property.isRequired || App.config.item.requireOrderProperties;


            return isRequired && this.variationMarkInvalidProperties && !this.property.value;
        },

        surcharge()
        {
            return this.property.itemSurcharge || this.property.surcharge;
        },

        footnotes()
        {
            if(this.surcharge > 0 && this.property.isRequired){
                return this.$translate("Ceres::Template.singleItemFootnote12");
            }
            if(this.surcharge <= 0 && this.property.isRequired){
                return this.$translate("Ceres::Template.singleItemFootnote2");
            }
            if(this.surcharge > 0 && !this.property.isRequired){
                return this.$translate("Ceres::Template.singleItemFootnote1");
            }
        },

        selectedDescription()
        {
            // const selectedProperty = this.property.selectionValues[this.selectionValue];
            //
            // return selectedProperty.description;
          return this.property.names.description
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        variationMarkInvalidProperties() {
            return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationMarkInvalidProperties;
        },

        isTouchDevice() {
            return !App.isSSR ? document.body.classList.contains("touch"): false;
        },

        ...mapState({
            isBasketLoading: state => state.basket.isBasketLoading,
        })
    },

    methods:
    {
        onInputValueChanged(value)
        {
            if (isNullOrUndefined(value) || value.length <= 0)
            {
                value = null;
            }

            this.$store.commit(`${this.itemId}/setVariationPropertySurcharges`, this.$store.getters[`${this.itemId}/variationBasePrice`]);
            console.log('oninputval change')
            this.setVariationOrderProperty({ propertyId: this.property.id, value: value });
        },

        validateInt(value)
        {
            value = parseInt(value);

            if (isNaN(value))
            {
                value = null;
            }

            this.inputValue = value;

            return value;
        },

        validateFloat(value)
        {
            const lastChar = value.slice(-1);

            const str = value.replace(App.decimalSeparator, ".");
            const arr = str.split(".");
            let toFixedLength = 0;

            if (arr.length === 2)
            {
                toFixedLength = arr[1].length;
            }

            value = parseFloat(str).toFixed(toFixedLength);

            if (isNaN(value))
            {
                value = null;
            }
            else
            {
                if (lastChar === "." || lastChar === App.decimalSeparator)
                {
                    value += lastChar;
                }

                value = value.toString().replace(".", App.decimalSeparator);
            }

            this.inputValue = value;

            return value;
        },

        setVariationOrderProperty(orderProperty) {
            return this.$store.commit(`${this.itemId}/setVariationOrderProperty`, orderProperty);
        },

        setPropertyFile(event)
        {
            if (event.target && event.target.files && event.target.files.length > 0)
            {
                this.selectedFile = event.target.files[0];
                this.uploadPropertyFile(this.selectedFile);
            }
        },

        uploadPropertyFile(file)
        {
            this.setIsBasketLoading(true);
            this.waiting = true;

            const fileData = new FormData();

            fileData.append("fileData", file);

            ApiService.post("/rest/io/order/property/file", fileData, { processData: false, contentType: false, cache: false, async: true, timeout: 60000, supressNotifications: true })
                .done(response =>
                {
                    this.setVariationOrderProperty({ propertyId: this.property.id, value: response });
                })
                .fail(error =>
                {
                    this.clearSelectedFile();
                    this._handleValidationErrors(error);
                })
                .always(response =>
                {
                    this.setIsBasketLoading(false);
                    this.waiting = false;
                });
        },

        clearSelectedFile()
        {
            this.selectedFile = null;
            this.setVariationOrderProperty({ propertyId: this.property.id, value: null });
            this.$refs.fileInput.value = "";
        },

        _handleValidationErrors(error)
        {
            if (error.hasOwnProperty("validation_errors"))
            {
                for (const err of Object.values(error.validation_errors))
                {
                    NotificationService.error(err[0]);
                }
            }

            if (error.error.message && error.error.message === "Post too large")
            {
                NotificationService.error(
                    this.$translate("Ceres::Template.errorPostTooLarge" , { maxSize: error.error.maxSize })
                );
            }
        },

        ...mapMutations([
            "setIsBasketLoading"
        ]),
    }
}
</script>
